export function isUnauthorizedError(error: Error): boolean {
  if ((error as any).status === 401) return true;
  return /^401: .*Unauthorized/.test(error.message);
}
